const influencerImage =
  "https://storage.googleapis.com/hatchways-crm.appspot.com/app-assets/signup_photo.jpeg";

const styles = {
  page: {
    position: "absolute",
    top: 0,
    bottom: 0,
    maxWidth: { xs: "auto", md: 1400 },
  },
  mobilePage: {
    backgroundColor: "primary.dark",
    position: "fixed",
    overflowY: "auto",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    justifyContent: "center",
    alignItems: "center",
    p: 1,
  },
  header: {
    fontFamily: "Inter Tight",
    fontWeight: 400,
    color: "white",
    fontSize: 40,
    mb: 2,
  },
  mobileHeader: {
    fontFamily: "Inter Tight",
    fontWeight: 400,
    color: "white",
    fontSize: 20,
    mb: 2,
  },
  image: {
    position: "relative",
    m: 1,
    borderRadius: 4,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundImage: `linear-gradient(to top, rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0)), url(${influencerImage})`,
  },
  content: {
    p: 3,
    position: "absolute",
    bottom: 0,
  },
  signUpFormContainer: {
    m: 1,
    mr: 0,
    borderRadius: 4,
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    alignItems: "center",
  },
  glass: {
    p: 2,
    borderRadius: 4,
    background: "rgba(145, 143, 143, 0.1)",
    boxShadow: "0 4px 30px rgba(0, 0, 0, 0.1)",
    backdropFilter: "blur(15px)",
    WebkitBackdropFilter: "blur(15px)",
  },
  card: {
    color: "white",
    position: "relative",
    p: 2,
    borderRadius: 4,
    background: "rgba(145, 143, 143, 0.1)",
    boxShadow: "0 4px 30px rgba(0, 0, 0, 0.1)",
    backdropFilter: "blur(15px)",
    WebkitBackdropFilter: "blur(15px)",
  },
  mobileCard: {
    px: 2,
    py: 0.5,
    border: "1px solid white",
    color: "white",
    borderRadius: 4,
    fontSize: 12,
  },
  littleCircle: {
    position: "absolute",
    top: 10,
    right: 10,
    width: 10,
    height: 10,
    borderRadius: "50%",
    mb: 1,
  },
  text: {
    color: { xs: "white", md: "primary.dark" },
    fontSize: 14,
    ml: { xs: 0, md: 2 },
    pt: { xs: 2, md: 0 },
  },
};

export default styles;
